"use client";

import * as React from "react";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";
import { Input } from "./input";

// CargoFL ShadCN Library — SearchForm.
export interface SearchFormProps {
  placeholder?: string;
  onSearch?: (q: string) => void;
  defaultValue?: string;
  className?: string;
}

function SearchForm({
  placeholder = "Search...",
  onSearch,
  defaultValue = "",
  className,
}: SearchFormProps) {
  const [value, setValue] = React.useState(defaultValue);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch?.(value);
  };

  return (
    <form
      role="search"
      onSubmit={handleSubmit}
      className={cn("relative w-full", className)}
    >
      <Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={(event) => {
          setValue(event.target.value);
          onSearch?.(event.target.value);
        }}
        className="pl-8"
      />
    </form>
  );
}
SearchForm.displayName = "SearchForm";

export { SearchForm };
